export default () => {
  const isAdmin = true;
  const permissions = [...(isAdmin ? ['Admin'] : [])];

  return [
    { namespace: 'wave', permissions: permissions, policies: [] },
    { namespace: 'rbac', permissions: permissions, policies: [] },
  ];
};
